import cognito from './auth.json' // eslint-disable-line
import cognitoProd from './auth-prod.json' // eslint-disable-line
import { env } from './env'

const auth = env.stage === 'prod' ? cognitoProd : cognito
const url = env.appUrl

export const awsConfig = {
	Auth: {
		region: auth.Auth.region,
		userPoolId: auth.Auth.userPoolId,
		userPoolWebClientId: auth.Auth.userPoolWebClientId,
		oauth: {
			domain: auth.Auth.domain,
			scope: ['openid', 'profile', 'email', 'aws.cognito.signin.user.admin'],
			redirectSignIn: url,
			redirectSignOut: url,
			responseType: 'code',
		},
	},
}

export const ApiConfig = {
	ControllerBaseUrl: env.apiBaseUrl,
}

export const S3Config = {
	BaseUrl: env.s3BaseUrl,
}

export const signUpConfig = {
	header: 'Oversight Sign Up',
	hideAllDefaults: true,
	hiddenDefaults: [],
	defaultCountryCode: '1',
	signUpFields: [
		{
			label: 'Email',
			key: 'email',
			required: true,
			displayOrder: 1,
			type: 'string',
			placeholder: 'Email',
		},
		{
			label: 'Password',
			key: 'password',
			required: true,
			displayOrder: 2,
			type: 'password',
			placeholder: 'Password',
		},
		{
			label: 'Given Name',
			key: 'given_name',
			required: true,
			displayOrder: 3,
			type: 'string',
			placeholder: 'Given Name',
		},
		{
			label: 'Family Name',
			key: 'family_name',
			required: true,
			displayOrder: 4,
			type: 'string',
			placeholder: 'Family Name',
		},
	],
}
